<template>
  <SortSearch default-sort="trending" dimension="TrendingGraphics" :force-experience="getDesign" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  },
  nuxtI18n: {
    paths: {
      en: '/design/trending-graphics/p/:page',
      es: '/design/graficos-de-tendencia/p/:page',
      pt: '/design/graficos-de-tendencia/p/:page',
      de: '/design/grafiken-im-trend/p/:page'
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, follow' }]
    };
  }
};
</script>
